export const UZ_PHONE_CODE = '998' as const;
